<template>
  <div class="statement-list">
    <div class="statement-list-filter">
      <SelectBox :options="dateOptions" @update="updateDateHandler" />
    </div>
    <div class="result-main-body">
      <StatementTable ref="statementTable" />
    </div>
    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
import SelectBox from '@/components/select-box.vue';
import StatementTable from '@/components/tables/statement.vue';
import BurgerMenu from '@/components/burger-menu.vue';
import { mapActions, mapGetters } from 'vuex';
import { isMobile } from 'mobile-device-detect';

export default {
  components: { SelectBox, BurgerMenu, StatementTable },
  data() {
    return {
      dateOptions: [
        { value: 'this week', label: 'This week' },
        { value: 'last week', label: 'Last week' },
      ],
      date: 'this week',
      isMobile,
    };
  },
  created() {
    this.getStatement();
  },
  methods: {
    ...mapActions('ticket', ['getTicketTotals']),
    updateDateHandler(date) {
      if (this.date === date) return;
      this.date = date;
      this.getStatement();
      this.$refs.statementTable.resetCollapse();
    },
    getStatement() {
      const params = this.generateTicketsParams();
      this.getTicketTotals(params);
    },
    getCorrectedMoment() {
      // Apply server time correction if device time differs from server time
      if (this.serverTimeDiff && Math.abs(this.serverTimeDiff) > 300000) {
        return this.$moment().add(this.serverTimeDiff, 'milliseconds');
      }
      return this.$moment();
    },
    generateTicketsParams() {
      const presetTimezone = this.isCreditUser ? 'Africa/Juba' : this.timezone;
      // Use corrected moment to account for device time mismatch
      let dayStr = this.getCorrectedMoment().tz(presetTimezone);
      let dayStart = dayStr.startOf('week').add(1, 'days').toISOString();
      let dayEnd = dayStr.endOf('week').add(1, 'days').toISOString();
      switch (this.date) {
        case 'last week':
          dayStr = this.getCorrectedMoment().tz(presetTimezone).subtract(1, 'weeks');
          dayStart = dayStr.startOf('week').add(1, 'days').toISOString();
          dayEnd = dayStr.endOf('week').add(1, 'days').toISOString();
          break;
      }
      return {
        from_bet_date_time: dayStart,
        to_bet_date_time: dayEnd,
      };
    },
  },
  computed: {
    ...mapGetters({
      isCreditUser: 'general/withCommission',
      timezone: 'general/timezone',
      serverTimeDiff: 'general/serverTimeDiff',
    }),
  },
};
</script>
<style lang="scss" scoped>
.statement-list {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px);

  &-filter {
    display: flex;
    padding: 0 16px;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 8px;
  }
  .result-main-body {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 100%;
  }
}
</style>
